// import IvanaSantacruz from '../../pages/IvanaSantacruz'
import IvanaSantacruz from '../../pages/ivana-santacruz/IvanaSantacruz'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.IVANA_SANTACRUZ, component: IvanaSantacruz },
])
